import React from "react";
import { Box, Typography, Container, Breadcrumbs, Link } from "@mui/material";
import AccordionFaq from "./AccordionFaq";
import SideNavbar from "../../../components/sideNavbar";
import { HelpCircle, ChevronRight } from "lucide-react";

function Faq() {
  return (
    <Box sx={{ display: { xs: 'block', md: 'flex' }, bgcolor: '#F8F9FC', minHeight: '100vh', width: '100%' }}>
      <SideNavbar />

      <Box sx={{ flexGrow: 1, ml: { md: '280px' }, width: '100%', transition: "margin 0.3s ease" }}>

        <Container maxWidth="xl" sx={{ mt: { xs: 2, md: 4 }, pb: 8 }}>

          {/* Page Header */}
          <Box sx={{ mb: 4, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Breadcrumbs
              separator={<ChevronRight size={14} color="#9CA3AF" />}
              sx={{ mb: 1.5, '& .MuiBreadcrumbs-li': { fontSize: '12px', fontWeight: 500 } }}
            >
              <Link underline="hover" color="#9CA3AF" href="/dashboard" sx={{ display: 'flex', alignItems: 'center' }}>
                Workspace
              </Link>
              <Typography color="#111827" sx={{ fontSize: '12px', fontWeight: 600 }}>Support</Typography>
            </Breadcrumbs>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                sx={{
                  p: 1.2,
                  bgcolor: '#EEF2FF',
                  borderRadius: '12px',
                  display: 'flex',
                  color: '#4F46E5',
                  boxShadow: '0 2px 8px rgba(79, 70, 229, 0.1)'
                }}
              >
                <HelpCircle size={28} />
              </Box>
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 800,
                    color: '#111827',
                    letterSpacing: "-0.02em",
                    fontSize: { xs: "1.75rem", md: "2.25rem" }
                  }}
                >
                  Solution FAQ's
                </Typography>
                <Typography variant="body2" sx={{ color: '#6B7280', fontWeight: 500 }}>
                  Find answers to commonly asked questions and workspace configurations.
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Content Area */}
          <Box
            sx={{
              bgcolor: "white",
              borderRadius: "20px",
              border: "1px solid #F0F0F5",
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
              p: { xs: 2, md: 4 },
              minHeight: "60vh"
            }}
          >
            <AccordionFaq />
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

export default Faq;
